/* eslint-disable */
/**
 * This file was generated by TypeScriptGen v0.0.2
 * Any changes to this file will be lost if regenerated 
 */
import Axios, {type AxiosResponse} from 'axios';
import {queryUrl, toFormData, defaultConfig, defaultFormConfig} from "./helper";
import type Agent from "./Agent";
import type PaginationResponse from "./PaginationResponse";
import type PaginationRequestSearch from "./PaginationRequestSearch";
import type IdName from "./IdName";
import type ReAssignRequest from "./ReAssignRequest";

const urls = {
    index(): string {
        return "/api/agent/index";
    }
}

export default {
    urls,
    index(): Promise<AxiosResponse<Agent[]>> {
        return Axios.get("/api/agent/index", defaultConfig);
    },
    paged(request: PaginationRequestSearch): Promise<AxiosResponse<PaginationResponse<Agent>>> {
        return Axios.post("/api/agent/paged", request, defaultConfig);
    },
    upsert(request: IdName): Promise<AxiosResponse> {
        return Axios.post("/api/agent/upsert", request, defaultConfig);
    },
    archive(request: ReAssignRequest): Promise<AxiosResponse> {
        return Axios.post("/api/agent/archive", request, defaultConfig);
    }
}
